import styles from './NormalModal.module.scss';
import Modal from '@components/modal/Modal';
import CloseIcon from '@assets/icons/close.svg?react'

type Props = {
  logoIcon?: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  open?: boolean;
  loading?: boolean;
  leftButton?: React.ReactNode;
  rightButton?: React.ReactNode;
  onClose?: () => void;
  className?: string;
};

function NormalModal(props: Props) {
  const { open, logoIcon, title, description, leftButton, rightButton, loading, className, onClose } = props;

  return (
    <Modal open={!!open} onClose={loading ? () => {} : onClose} closeButton={false} className={`${styles.wrapper} ${className}`}>
      <div className={styles.mainView}>
        <div className={styles.logo}>{logoIcon}</div>
        {onClose && (
          <div className={styles.closeIcon} role='button' onClick={onClose}>
            <CloseIcon />
          </div>
        )}
        <div className={styles.title}>{title}</div>
        <div className={styles.detail}>{description}</div>
          <div className={styles.content}>
            <div className={styles.action}>
              {leftButton}
              {rightButton}
            </div>
          </div>
      </div>
    </Modal>
  );
}

export default NormalModal;
